// styles.js
import { styled } from "@mui/system";

export const Styles = styled("div")(({ theme }) => ({
  ".main-container": {
    paddingInline: "100px",
    [theme.breakpoints.down("lg")]: { paddingInline: "50px" },
    [theme.breakpoints.down("md")]: { paddingInline: "30px" },
    ".logo": {
      width: "160px",
      [theme.breakpoints.down("md")]: { width: "120px" },
      [theme.breakpoints.down("sm")]: { width: "100px" },
    },
    ".links-container": {
      gap: "20px",
      marginRight: "10px",
      a: {
        fontSize: "14px",
        fontWeight: 500,
      },
      [theme.breakpoints.down("md")]: { gap: "25px" },
      [theme.breakpoints.down("sm")]: { gap: "15px" },
      // Optional: adjust typography on smaller screens if needed
      [theme.breakpoints.down("lg")]: {
        a: {
          fontWeight: 400,
          fontSize: "12px",
        },
      },
      /* Hide scrollbar */
      overflowX: "auto",
      scrollbarWidth: "none", // Firefox
      "&::-webkit-scrollbar": {
        display: "none", // Chrome, Safari, Opera
      },
    },
  },
}));
